var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable",on:{"click":_vm.onGroupAdd}},[_c('i',{staticClass:"mdi mdi-plus-circle-outline"}),_vm._v("\n  Insertar grupo\n")])}
var staticRenderFns = []

export { render, staticRenderFns }